import React from "react"
import debounce from "debounce-promise"
import AsyncSelect, { components } from "react-select/lib/Async"
import "./AsyncOrderField.css"
import { MagnifierIcon, CloseIcon } from "../../Icons"
import { API } from "../../../api"

const getOptions = async (inputValue, callback) => {
  if (!inputValue) {
    return callback([])
  }
  try {
    const response = await API.get(`/orders/customers?keyword=${inputValue}`)
    const { data } = response
    const newCustomerList = data.customers.map(customer => ({
      value: customer.id,
      label: `${customer.firstname} ${customer.lastname}`,
      firstname: customer.firstname,
      lastname: customer.lastname,
      email: customer.email,
      phone: customer.mobile,
      ccPhone: customer.mobile_country_code,
      photo: customer.photo_url,
      birthday: customer.birthday,
      notes: customer.notes,
      gender: customer.gender,
      groups: data.customer_groups.map(i => i.groups)
    }))
    return callback(newCustomerList)
  } catch (error) {
    console.log(error)
    return callback([])
  }
}

const debounceFetch = debounce(getOptions, 1000, {
  leading: true
})

const selectStyle = {
  clearIndicator: () => ({}),
  container: () => ({}),
  control: () => ({}),
  dropdownIndicator: () => ({}),
  group: () => ({}),
  groupHeading: () => ({}),
  indicatorsContainer: () => ({}),
  indicatorSeparator: () => ({}),
  input: () => ({}),
  menu: () => ({}),
  menuList: () => ({}),
  menuPortal: () => ({}),
  multiValue: () => ({}),
  multiValueLabel: () => ({}),
  multiValueRemove: () => ({}),
  noOptionsMessage: () => ({}),
  option: () => ({}),
  placeholder: () => ({}),
  singleValue: () => ({}),
  valueContainer: () => ({})
}

function Menu(props) {
  const { children, innerRef, innerProps } = props
  return (
    <div className={`Menu ${props.placement}`} {...innerProps} ref={innerRef}>
      <div className="menu-content">{children}</div>
    </div>
  )
}

function RemoveValue(props) {
  return (
    <components.MultiValueRemove {...props}>
      <CloseIcon />
    </components.MultiValueRemove>
  )
}
class AsyncOrderField extends React.Component {
  state = {
    inputValue: "",
    typing: false,
    typingTimeout: 0
  }

  handleChange(data, { action }) {
    const { form, field } = this.props
    form.setFieldTouched(field.name)
    switch (action) {
      case "select-option":
      case "remove-value":
        form.setFieldValue(field.name, data)
        break
      default:
        break
    }
  }

  render() {
    const props = this.props
    const {
      field,
      form: { touched, errors }
    } = this.props

    let status = "default"
    if (touched[field.name] && errors[field.name]) {
      status = "has-error"
    } else if (
      touched[field.name] &&
      field.value &&
      field.value.length &&
      !errors[field.name]
    ) {
      status = "is-fixed"
    }

    return (
      <>
        <AsyncSelect
          className={`AsyncOrderField ${status}`}
          classNamePrefix="AsyncOrderField"
          styles={selectStyle}
          isClearable={false}
          menuPlacement="auto"
          cacheOptions
          loadOptions={debounceFetch}
          defaultOptions={this.props.defaultOptions}
          {...props}
          components={{
            ...props.components,
            Menu: { ...props.components }.hasOwnProperty("Menu")
              ? { ...props.components }.Menu
              : Menu,
            DropdownIndicator: () => <MagnifierIcon />,
            MultiValueRemove: RemoveValue
          }}
        />
        {touched[field.name] &&
          errors[field.name] && (
            <div className="error-message">{errors[field.name]}</div>
          )}
      </>
    )
  }
}

export default AsyncOrderField
